import { useSEO } from "../components/SEO";
import { PageHero, Reveal, SectionTag } from "../components/Reveal";
import { ArrowLink } from "../components/CTA";
import { CtaBand } from "../components/CtaBand";
import { ARTICLES } from "../data/articles";

export default function Resources() {
  useSEO(
    "Hajj & Umrah Marketing Resources for Indian Travel Agencies | Nexus Catalyst",
    "Practical guides on Hajj and Umrah marketing in India: lead generation, Meta Ads, Google Ads, WhatsApp, costs and converting enquiries into bookings."
  );

  return (
    <main data-testid="resources-page">
      <PageHero
        tag="Resource Hub"
        testid="resources-hero"
        crumbs={[{ label: "Resources", to: "/resources" }]}
        lines={[
          "Hajj & Umrah marketing,",
          <span className="text-tan">explained properly.</span>,
        ]}
        copy="Practical, honest guides for Indian Hajj and Umrah travel agencies: lead generation, advertising, WhatsApp, costs and conversion. No hype, no invented numbers."
      />

      <section className="bg-white py-20 md:py-28" data-testid="resources-grid">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-6">
            {ARTICLES.map((a, i) => (
              <Reveal key={a.slug} delay={i * 0.05} className="h-full">
                <article
                  className="h-full bg-cream border border-charcoal/10 p-8 flex flex-col transition-colors duration-300 hover:border-gold/50"
                  data-testid={`resource-card-${a.slug}`}
                >
                  <span className="self-start border border-gold/40 bg-white px-3 py-1 text-[10px] font-semibold tracking-[0.2em] uppercase text-tan">
                    {a.cluster}
                  </span>
                  <h2 className="mt-5 text-xl md:text-2xl font-semibold tracking-tight text-charcoal leading-snug">
                    {a.title}
                  </h2>
                  <p className="mt-3 text-sm text-charcoal/60 leading-relaxed flex-1">
                    {a.description}
                  </p>
                  <ArrowLink
                    to={`/resources/${a.slug}`}
                    testid={`resource-link-${a.slug}`}
                    className="mt-6"
                  >
                    Read the Guide
                  </ArrowLink>
                </article>
              </Reveal>
            ))}
          </div>

          <Reveal delay={0.15} className="mt-16">
            <div className="border border-gold/30 bg-cream p-6 md:p-8 flex flex-col md:flex-row md:items-center justify-between gap-6">
              <div>
                <SectionTag className="mb-3">Services</SectionTag>
                <p className="text-lg font-semibold tracking-tight text-charcoal">
                  Prefer to see what done-for-you looks like?
                </p>
              </div>
              <div className="flex flex-wrap gap-5">
                <ArrowLink to="/services" testid="resources-services-link">
                  Explore Services
                </ArrowLink>
                <ArrowLink to="/pricing" testid="resources-pricing-link">
                  See Pricing
                </ArrowLink>
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      <CtaBand
        title="Reading Is Good. A Plan Is Better."
        copy="Book a strategy call and we will apply these ideas to your agency's specific market, packages and season."
        testid="resources-cta-band"
      />
    </main>
  );
}
